/**
 * Camera Kit Web Demo Settings
 * Centralized configuration for the application
 */

const width1 = Math.floor(window.innerWidth / 2) * 2;
const height1 = Math.floor(window.innerHeight / 2) * 2;
export const Settings = {
  // Camera settings
  camera: {
    fps: 30,
    constraints: {
      front: {
        video: {
          facingMode: { exact: "user" },
        },
        audio: true,
      },
      back: {
        video: {
          facingMode: { exact: "environment" },
        },
        audio: true,
      },
      desktop: {
        video: {
          facingMode: "user",
        },
        audio: true,
      },
    },
  },

  // Recording settings
  recording: {
    mimeType: "video/mp4", // Reverted to original mimeType
    fps: 30,
    get outputFileName() {
      const now = new Date();
      const timestamp = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(
        now.getHours()
      ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
        now.getSeconds()
      ).padStart(2, "0")}`;
      return `augment.ing_${timestamp}.mp4`; // Reverted file extension to mp4
    },
  },

  // FFmpeg settings
  ffmpeg: {
    baseURL: "/ffmpeg",
    coreURL: "ffmpeg-core.js",
    wasmURL: "ffmpeg-core.wasm",
    outputOptions: [
      "-vf",
      `scale=${width1}:${height1}`,
      "-preset",
      "ultrafast",
      "-crf",
      "23",
      "-c:v",
      "libx264",
      "-c:a",
      "aac",
      "-strict",
      "experimental",
      "-movflags",
      "faststart",
    ],
  },
};
